import styles from './screen-reader-only.module.scss';
import {
	type ComponentType,
	type HTMLAttributes,
	type LabelHTMLAttributes,
} from 'react';

const ScreenReaderOnly = ({ Element = 'span', text, ...restProps }: Props) => {
	return (
		<Element {...restProps} className={styles.text}>
			{text}
		</Element>
	);
};

export type Props = {
	Element?: ComponentType<any> | string;
	text: string;
} & HTMLAttributes<HTMLElement> &
	LabelHTMLAttributes<HTMLLabelElement>;
export default ScreenReaderOnly;
